import { render, staticRenderFns } from "./PaymentComplete.vue?vue&type=template&id=b072f7be&"
import script from "./PaymentComplete.vue?vue&type=script&lang=js&"
export * from "./PaymentComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports